import React from 'react'
import styled from 'styled-components'
import { Container } from 'react-bootstrap'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Title from '../../../common/Section/SectionTitle'
import Condition from './Condition'
import SlidingWorkers from './SlidingWorkers'
import Theme from '../../../../vars/ThemeOptions'
 
const Wrap = styled.div`

`

const WrapCont = styled(Container)`
  position: relative;
  .intro-wrap {
    width: 70%;
    position: relative;
    z-index: 10;
  }
  p {
    color: ${Theme.hex('grayText')};
    font-size: .95rem;
    margin-bottom: 1.5rem;
  }
`
 
const Hero = ({ title, introText, conditions }) => {
  return (
    <Wrap>
      <WrapCont>
        <SlidingWorkers />
        <Title title={title} />
        <div className="intro-wrap">
          {documentToReactComponents(introText)}
        </div>    
        {conditions.map((condition, i) => (
          <Condition condition={condition} color={i === 0 ? 'green' : i === 1 ? 'yellow' : 'red'}  key={condition.title + i}/>
        ))}       
      </WrapCont>
    </Wrap>
  )
}
 
export default Hero